<template>
    <div class="kiaf-nav-bar">
        <my-nav-bar :customize="customize" :keepAliveMax="keepAliveMax" :webviewMax="webviewMax"  @gohome="gohome">
            <template #businessIconBox><slot name="businessIconBox"></slot></template>
            <template #mapIconBox><slot name="mapIconBox"></slot></template>
            <template #businessNavBarBox><slot name="businessNavBarBox"></slot></template>
            <template #mapNavBarBox><slot name="mapNavBarBox"></slot></template>
            <template #personalSettingMiddleForm><slot name="personalSettingMiddleForm"></slot></template>
            <template #personCenterIconBox><slot name="personCenterIconBox"></slot></template>
            <template #personCenterInfo><slot name="personCenterInfo"></slot></template>
            <template #customNavbar><slot name="customNavbar"></slot></template>
            <template #searchBox><slot name="searchBox"></slot></template>
            <slot></slot>
        </my-nav-bar>
    </div>
</template>
<script>
  import Auth from '../../../utils/auth';
  import Global from '../../../utils/global';
  import Util from '../../../utils/util';
  import Constants from '../../../utils/constants';
  import {postMessage, onMessage, closeExpiredMessage} from '../../../utils/event-bus';
  import {refreshTokenApi} from '../../service/login';
  import {defineAsyncComponent} from '@vue/composition-api';
  // import IosmetricMode from './IsometricMode/index';
  // import BusinessMapMode from './BusinessMapMode/index';
  // import SimpleMode from './SimpleMode/index';
  // import MyNavBar from './PhotoMode/index';
  // import BlankMode from './BlankMode/index';
  // import Vue from 'vue';
  export default {
    name: 'KiafNavBar',
    components: {
        // MyNavBar,
      // IosmetricMode,
      // BusinessMapMode,
      // SimpleMode,
      // PhotoMode,
      // BlankMode
    },
    data() {
      return {
        activedMenu: {},
        recylceTimer: null,
        refreshTokenTimer: null
      };
    },
    props: {
      mode: {
        type: String,
        default: 'business&map'//'business&map' or 'simple'
      },
      customize: {
        type: Object,
        default() {
          return {};
        }
      },
      sidebar: {
        type: Object,
        default: () => {
          let data = {
            opened: 0,
            withoutAnimation: false
          };
          return data;
        }
      },
      keepAliveMax: {
        type: Number,
        default: 0
      },
      webviewMax: {
        type: Number,
        default: 0
      }
    },
    watch: {   //监听路由变化
      $route(to, from) {
        if(this.recylceTimer){
          clearTimeout(this.recylceTimer);
        }
        this.recylceTimer = setTimeout(() => {
          closeExpiredMessage();
        }, 10000);

        // console.log('watch route from>>>', from);
        // console.log('watch route to>>>', to);
        let matchPath = this.$util.getMatchPath(to.fullPath);
        this.checkMenu(matchPath, this.$store.state.kiaf.menuData);
        if(this.activedMenu.id){
          this.$store.commit('KIAF_SET_V_MENUACTIVEINDEX', this.activedMenu.id);
          this.$store.commit('KIAF_SET_MENUACTIVEINDEX', this.activedMenu.id);
          sessionStorage.setItem(Constants.STORAGE_KEY_LAST_ACTIVE_ID, this.activedMenu.id);
        }
      }
    },
    methods: {
      gohome(val){
        this.$emit('gohome', val);
      },
      checkMenu(url, menus) {
        menus.map(item => {
          if (Util.getMatchPath(item.url) == url) {
            this.activedMenu = {...item};
          } else{
            if(Array.isArray(item.children)){
              this.checkMenu(url, item.children);
            }
          }
        });
      },
      beforeunloadHandler(e) {
        if(!Global.isSubWindow()){
          postMessage(Constants.EVENT_BUS_CODE_CLOSE_ALL_WIN, {}, null, true);
          // let jwtToken = Auth.getJwtToken();
          // let sessionWindowId = Global.getSessionWindowId();
          // let find = Global.getWindows().find((item) => { return item.windowId == sessionWindowId; }); // 主窗口
          // if(find && jwtToken && Global.isPopUp() && Global.getWindows().length == 1){
          //   Auth.clearJwtToken();
          //   sessionStorage.setItem(Constants.STORAGE_KEY_TEMP_JWT_TOKEN, jwtToken);//临时保存jwtotken，如果是刷新，则在Auth.nextrouter中重新获取后赋值，如果时关闭窗口，则sessionStorage会消失，所以安全
          // }
        }
      }
    },
    beforeCreate(){
      if(Global.isPopUp() || (Global.isAppPortalWebview() && Global.getWindows().length >= 2)){
        let windows = Global.getWindows();
        try {
          windows.forEach(win => {
            if (!window[win.windowId] && window.opener && window.opener[win.windowId]) { //非常重要，用来获取弹出的所有窗口，在联动关闭窗口时会用到
              window[win.windowId] = window.opener[win.windowId];
            }
          });
        }catch (e) {

        }
      }
      postMessage(Constants.EVENT_BUS_CODE_CLOSE_LOGIN_WIN);
      onMessage(Constants.EVENT_BUS_CODE_CLOSE_ALL_WIN);
      onMessage(Constants.EVENT_BUS_CODE_CHECK_LOGINED, (data) => {
        postMessage(Constants.EVENT_BUS_CODE_CHECK_LOGINED_CALLBACK, {status: true});
      }, this);
      onMessage(Constants.EVENT_BUS_CODE_LOGOUT, () => {
        Auth.exit();
      });
      if(!Util.isWindowMap()){
        onMessage(Constants.EVENT_BUS_CODE_OPEN_EXTERNAL_WEBVIEW, (data) => {
          let params = {
            id: 0,
            url: '',
            sign: '',
            external: true,
            internal: false
          };
          params.id = new Date().getTime();
          params.sign = data.sign || '';
          params.url = data.url;
          let query = 'jwt_token=' + Auth.getJwtToken() + '&refresh_token=' + Auth.getRefreshToken() + '&parent_app_host=' + encodeURIComponent(Util.getHost());
          if(params.url.indexOf('?') < 0){
            params.url = params.url + '?' + query;
          } else {
            params.url = params.url + '&' + query;
          }
          params.url += '&webview_mode=external';
          this.$store.commit('KIAF_SET_WEBVIEW', params);
        });
        onMessage(Constants.EVENT_BUS_CODE_OPEN_INTERNAL_WEBVIEW, (data) => {
          let params = {
            id: 0,
            url: '',
            sign: '',
            external: false,
            internal: true
          };
          params.id = new Date().getTime();
          params.sign = data.sign || '';
          params.url = data.url;
          let query = 'jwt_token=' + Auth.getJwtToken() + '&refresh_token=' + Auth.getRefreshToken() + '&parent_app_host=' + encodeURIComponent(Util.getHost());
          if(params.url.indexOf('?') < 0){
            params.url = params.url + '?' + query;
          } else {
            params.url = params.url + '&' + query;
          }
          params.url += '&webview_mode=internal';
          this.$store.commit('KIAF_SET_WEBVIEW', params);
        });
      }
      if(Global.isAppPortalWebview()){
        console.log('isAppPortalWebview>>>', Global.isAppPortalWebview());
        if(!Util.isEmpty(Global.getParentAppHost()) && Global.getParentAppHost().indexOf('http:') != 0 && Global.getParentAppHost().indexOf('https:') != 0){
          let appPortalChannel = Global.getParentAppHost();
          try {
            let bc = new window.BroadcastChannel(appPortalChannel);
            bc.addEventListener('message', (res) => {
              let currEventCode = '';
              if(res.data){
                currEventCode = res.data.eventCode;
              }
              if(currEventCode === Constants.EVENT_BUS_CODE_APP_PORTAL_CLOSE_ALL_WIN){
                Util.closeAllWindow();
              }
            });
          }catch (e) {
            console.error(e);
          }
        } else {
          onMessage(Constants.EVENT_BUS_CODE_APP_PORTAL_CLOSE_ALL_WIN, (msg) => {
            console.log('cross domain message>>>', msg);
            Util.closeAllWindow();
          });
        }
      }
    },
    created(){
      if(this.mode === 'business&map'){
        // this.$global.getVue().component('MyNavBar', function (resolve) {
        //   require(['./BusinessMapMode/index'], resolve);
        // });
          this.$global.getVue().component('MyNavBar', defineAsyncComponent(() => import('./BusinessMapMode/index')));
      } else if(this.mode === 'isometric'){
        //   this.$global.getVue().component('MyNavBar', function (resolve) {
        //   require(['./IsometricMode/index'], resolve);
        // });
          this.$global.getVue().component('MyNavBar', defineAsyncComponent(() => import('./IsometricMode/index')));
      } else if(this.mode === 'simple'){
        //   this.$global.getVue().component('MyNavBar', function (resolve) {
        //   require(['./SimpleMode/index'], resolve);
        // });
          this.$global.getVue().component('MyNavBar', defineAsyncComponent(() => import('./SimpleMode/index')));
      } else if(this.mode === 'photo'){
        //   this.$global.getVue().component('MyNavBar', function (resolve) {
        //   require(['./PhotoMode/index'], resolve);
        // });
          this.$global.getVue().component('MyNavBar', defineAsyncComponent(() => import('./PhotoMode/index')));
      } else if(this.mode === 'baidu'){
        //   this.$global.getVue().component('MyNavBar', function (resolve) {
        //   require(['./BaiduMode/index'], resolve);
        // });
          this.$global.getVue().component('MyNavBar', defineAsyncComponent(() => import('./BaiduMode/index')));
      } else {
        //   this.$global.getVue().component('MyNavBar', function (resolve) {
        //   require(['./BlankMode/index'], resolve);
        // });
          this.$global.getVue().component('MyNavBar', defineAsyncComponent(() => import('./BlankMode/index')));
      }
      // const routerPush = VueRouter.prototype.push;
      // let that = this;
      // VueRouter.prototype.push = function push(location) {
      //   if(that.$route.path.indexOf('/kiaf/webview') < 0) {
      //     that.$store.commit('KIAF_INIT_WEBVIEW', {});
      //   }
      //   return routerPush.call(this, location).catch(error => error);
      // };

      onMessage(Constants.EVENT_BUS_CODE_MENU_ITEM_CLICK, (data) => {
        if(this.customize.handleOnMenuItemClick && typeof this.customize.handleOnMenuItemClick === 'function'){
          this.customize.handleOnMenuItemClick(data);
        }
      });
        if((Global.isPopUp() && Global.isPreloadMode() && Util.isChromeExtensionWindow()) || (Global.isPopUp() && Global.getWindows().length == 1) || Global.isAppPortalWebview()) {
            if (Auth.getJwtToken()) {
              Auth.addFreshEvent();
            }
        }
      let documentTitle = Global.getDocumentTitle() || (Global.getAppPortalTarget() && document.title === 'KEDACOM');
      if(documentTitle){
        document.title = decodeURIComponent(documentTitle);
      }

      // 针对门户打开的窗口获取监视器数量
      if(Util.isChromeExtensionWindow()){
        Util.requestChromeExtScreens();
      }
      window.onmessage = function(message){
        console.log('message.data>>>', message.data);
        if(message.data && message.data.action === 'CHROME_EXT_CHANGE_PAGE'){
          console.log('message.data.message.data.url>>>', message.data.message.data.url);
          location.href = message.data.message.data.url;
        } else if(message.data && message.data.action === 'CHROME_EXT_GET_SCREENS'){
          console.log('message.data.action>>>', message.data.action);
          console.log('message.data.message.value>>>', message.data.message.value);
          Global.setScreenCount(message.data.message.value.length);
        }
      };
    },
    mounted(){
      window.addEventListener('beforeunload', e => this.beforeunloadHandler(e));
      if(!Util.isWindowMap()){
        if(!this.refreshTokenTimer && !Global.isDisableRefreshToken()){
          let expiresIn = this.$auth.getUserInfo()['expiresIn'] || 7200;
          let rate = 0.9;
          if(Global.getCustomConfig()['KIAF_REFRESH_TOKEN_INTERVAL'] && !isNaN(Global.getCustomConfig()['KIAF_REFRESH_TOKEN_INTERVAL'])){
            rate = Number(Global.getCustomConfig()['KIAF_REFRESH_TOKEN_INTERVAL']);
          }
          let interval = parseInt(expiresIn * rate);
          if(interval < 20){
            interval = 20;
          }
          console.log('refresh token>>>', interval);
          this.refreshTokenTimer = setInterval(() => {
            refreshTokenApi();
          }, interval * 1000);
        }
        onMessage(Constants.EVENT_BUS_CODE_SWITCH_WINDOW, (data) => {
          if(data && data.windowId){
            Util.switchWindow(data.windowId);
          } else if(data && data.toBusiness){
            Util.switchWindow(null, true);
          } else if(data && data.toMap){
            Util.switchWindow(null, false);
          }
        });
      }
      setTimeout(() => { //延迟500毫秒，避免插件模式下，插件模式下chromeExt元素没有写入到dom中
        let isFirstLoad = sessionStorage.getItem(Constants.STORAGE_KEY_FIRST_LOAD);
        if(isFirstLoad != 'N'){
          sessionStorage.setItem(Constants.STORAGE_KEY_FIRST_LOAD, 'N');
          if (!Util.isChromeExtensionWindow() && !Global.isExternalWebview() && !Global.isInternalWebview() && !Global.isAppPortalWebview() && !Util.isIE() && Global.getWindows().length >= 2) {
            if (Util.isWindowMap()) {
              Util.switchWindow(null, true);
            } else {
              Util.switchWindow(null, false);
            }
          }
        }
      }, 500);
    },
    beforeDestroy() {
      clearInterval(this.refreshTokenTimer);
      window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e));
    }

  };
</script>
